import React from 'react';
import styled, { css } from 'styled-components';
import TEST_IDS from '../../utils/_tests/testIds.constants';
import FullScreenModal from './FullScreenModal';
import ColorConstants from '../../constants/ColorConstants';
import RoundedButtonWithArrow from '../inputs/buttons/RoundedButtonWithArrow';
import DismissButton from '../inputs/buttons/DismissButton';
import { MobileScreen } from '../styles/ConstantMediaQuery';
import ImageConstants from '../../constants/ImageConstants';

const defaultProps = {
    textCancel: gettext('Cancel'),
    textDelete: gettext('Delete'),
    isLoading: false,
};

const contentStyles = css`
    padding-bottom: 0;
    @media ${MobileScreen} {
        padding-bottom: 0;
    }
`;

interface DeleteModalProps{
    onClose: Function;
    isOpen: boolean;
    onDeleteClick: string;
    title: string;
    subtitle: string;
    textCancel: string;
    textDelete: string;
    isLoading: boolean;
    children: React.ReactChild;
}

const DeleteModal = ({
    onClose,
    isOpen,
    onDeleteClick,
    title,
    subtitle,
    textCancel,
    textDelete,
    isLoading,
    children,
}:DeleteModalProps) => (
    <FullScreenModal
        isOpen={isOpen}
        onClose={onClose}
        iconColor={ColorConstants.white}
        isNewModal
        styles={contentStyles}
    >
        <ContentWrapper>
            <div style={{ width: '95%', maxWidth: '550px' }}>
                <TitleWrapper>
                    <Title data-testid={TEST_IDS.MANAGE_SETTINGS.MODAL_DELETE_TITLE}>
                        {title}
                    </Title>
                    <Subtitle>{subtitle}</Subtitle>
                </TitleWrapper>
                {children}
                <ButtonsWrapper>
                    <DismissButton
                        background={ColorConstants['catskill-white']}
                        color={ColorConstants['regal-blue']}
                        label={textCancel}
                        onClick={onClose}
                        data-testid={TEST_IDS.MANAGE_SETTINGS.MODAL_CANCEL_BUTTON}
                    />
                    <RoundedButtonWithArrow
                        background={ColorConstants.salmon}
                        color={ColorConstants.white}
                        label={textDelete}
                        onClick={onDeleteClick}
                        isLoading={isLoading}
                        data-testid={TEST_IDS.MANAGE_SETTINGS.MODAL_DELETE_BUTTON}
                    />
                </ButtonsWrapper>
            </div>
        </ContentWrapper>
    </FullScreenModal>
);

const ContentWrapper = styled.div`
    background-color: ${ColorConstants.violet};
    background-image: url("${ImageConstants.CARD_HEADER_BACKGROUND.DELETE_COMPANY.SRC2}"),
    url("${ImageConstants.CARD_HEADER_BACKGROUND.DELETE_COMPANY.SRC1}");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
`;

const TitleWrapper = styled.div`
    color: ${ColorConstants.white};
    text-align: center;
    font-family: Helvetica;
`;

const Title = styled.h1`
    font-size: 36px;
    font-weight: bold;
`;

const Subtitle = styled.h2`
    font-size: 15px;
`;

const ButtonsWrapper = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding-top: 40px;
    min-width: 450px;
    min-height: auto;
    @media ${MobileScreen} {
        flex-direction: column-reverse;
        padding-top: 20px;
        min-width: auto;
        min-height: 160px;
    }
`;

DeleteModal.defaultProps = defaultProps;

export default DeleteModal;
